import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { Button, Col, PageHeader, Panel, Row } from 'react-bootstrap'
import { push as pushPath } from 'react-router-redux'

import { SignupWithExternalsRecord } from 'internal-components/src/records'
import { makeSelectLoading } from 'internal-components/src/redux/modules/loading'
import { selectSignupsWithExternals } from 'internal-components/src/redux/modules/signup/selectors'

import PageLoading from '../../components/Layout/PageLoading'
import {
  advanceToOffer,
  begin,
  setAddress,
  setAddressLocId,
} from '../../redux/modules/signupEdit/actions'
import {
  selectEditSignupWithExternals,
  selectErrorsByPath,
} from '../../redux/modules/signupEdit/selectors'
import SignupList from '../../components/SignupList'
import AddressEntry from '../../components/Signup/AddressEntry'

import './StartView.css'

export class StartView extends React.Component {
  componentWillMount() {
    if (!this.props.signupWithExternals) {
      this.props.begin()
    }
  }

  handleSubmit = e => {
    e.preventDefault()

    this.props.advanceToOffer()
  }

  render() {
    const signup = this.props.signupWithExternals
      ? this.props.signupWithExternals.signup
      : null
    const offer = this.props.signupWithExternals
      ? this.props.signupWithExternals.offer
      : null

    return (
      <section className="container">
        <PageHeader>Sign up for Infinite Networks</PageHeader>

        <form onSubmit={this.handleSubmit} noValidate>
          <Row>
            <Col md={12}>
              <p>
                To sign up for our internet services, please enter your premises
                address so we can present the best options that are available at
                that location.
              </p>

              <p>
                If you&apos;re after a virtual service that doesn&apos;t require
                an address, leave the address blank or push the{' '}
                <em>Continue without address</em> button below.
              </p>

              <AddressEntry
                address={signup ? signup.address : ''}
                errors={this.props.errors}
                setAddress={this.props.setAddress}
                setAddressLocId={this.props.setAddressLocId}
              />

              <div>
                {offer && (
                  <Panel className="offer-set">
                    <Panel.Body>
                      Signing up for <b>{offer.name}</b>
                    </Panel.Body>
                  </Panel>
                )}

                <Button
                  className="pull-right"
                  id="submit-no-address"
                  onClick={() => this.props.setAddress('')}
                  type="submit"
                >
                  Continue without Address &rarr;
                </Button>
              </div>
            </Col>
          </Row>
        </form>

        {this.props.hasRemembered && (
          <div>
            <hr />
            {this.props.incompleteSignups.size > 0 && (
              <div>
                <h3>Incomplete Signups</h3>

                <p>
                  This list contains any signups that you have not yet
                  completed, and have not been submitted to Infinite for
                  processing. You can continue a signup by clicking on it.
                </p>

                <p>
                  Any incomplete signups will be cancelled after 7 days of
                  inactivity.
                </p>

                <SignupList
                  pushPath={pushPath}
                  signups={this.props.incompleteSignups}
                />
              </div>
            )}

            <h3>Your Existing Signups</h3>

            <p>
              All of your submitted signups and their progress through the
              installation process are listed here.
            </p>

            {this.props.loading && <PageLoading />}

            {!this.props.loading && (
              <SignupList
                pushPath={this.props.pushPath}
                signups={this.props.signups}
              />
            )}
          </div>
        )}
      </section>
    )
  }
}

StartView.propTypes = {
  advanceToOffer: Pt.func.isRequired,
  begin: Pt.func.isRequired,
  errors: Ipt.map.isRequired,
  hasRemembered: Pt.bool.isRequired,
  incompleteSignups: Ipt.orderedSetOf(Pt.instanceOf(SignupWithExternalsRecord))
    .isRequired,
  loading: Pt.bool.isRequired,
  pushPath: Pt.func.isRequired,
  setAddress: Pt.func.isRequired,
  setAddressLocId: Pt.func.isRequired,
  signups: Ipt.orderedSetOf(SignupWithExternalsRecord).isRequired,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord),
}

const mapStateToProps = () => {
  const selectLoading = makeSelectLoading()

  return state => {
    const signups = selectSignupsWithExternals(state, {})

    return {
      errors: selectErrorsByPath(state.signupEdit),
      hasRemembered: state.signupEdit.get('knownSignups').size > 0,
      incompleteSignups: signups.filter(swe => swe.signup.state === 'new'),
      loading: selectLoading(state, { type: ['signup', 'products', 'offers'] }),
      signupWithExternals: selectEditSignupWithExternals(state, {
        sortBy: null,
      }),
      signups: signups.filter(swe => swe.signup.state !== 'new'),
    }
  }
}

export default connect(
  mapStateToProps,
  {
    advanceToOffer,
    begin,
    pushPath,
    setAddress,
    setAddressLocId,
  },
)(StartView)



// WEBPACK FOOTER //
// ./src/views/SignupForm/StartView.jsx